import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ToggleButton from "../../../Components/common/ToggleButton/ToggleButton";
import "./styles.scss";
import { Modal } from "@mui/material";
import Login from "../Login/Login";
import IyzicoIcon from "../../../Components/Icon-SVG/IyzicoIcon";
import PricePopup from "../../CloudCommon/PricePopup/PricePopup";

const Pricing = () => {
  const [isMonthly, setIsMonthly] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [userCheck, setUserCheck] = useState(false);
  const user = useSelector((state) => state.users.user);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContentType, setPopupContentType] = useState("");

  const handleLinkClick = (contentType) => {
    setPopupContentType(contentType);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContentType("");
  };

  useEffect(() => {
    if (user) {
      setUserCheck(true);
    } else {
      setUserCheck(false);
    }
  }, [user]);

  const loginCall = () => {
    if (userCheck) {
      setIsLoginOpen(false);
    } else {
      setIsLoginOpen(true);
    }
  };

  function handleToggle(value) {
    setIsMonthly(value);
  }

  return (
    <div className="pricing">
      <h1>Our Pricing</h1>

      <div className="pricing__selector">
        <ToggleButton
          leftText="Annually"
          rightText="Monthly"
          active={isMonthly}
          onClick={handleToggle}
        />
      </div>

      <div id="cards" className="pricing__cards">
        <div className="pricing__cards-left">
          <h2>Basic</h2>
          {isMonthly ? <h3 className="monthly">$4.99</h3> : <h4 className="annually">$49.99</h4>}
          <hr />
          <p>Windows </p>
          <hr />
          <p>Quick Submission </p>
          <hr />
          <p>
            <b>Submission call daily:</b> 50
          </p>
          <hr />
          <p>
            <b>API call daily:</b> 10
          </p>
          <hr />
          <button onClick={() => loginCall()}>Buy</button>
        </div>
        <div className="pricing__cards-middle">
          <h2>Standart</h2>
          {isMonthly ? <h3 className="monthly">$9.99</h3> : <h4 className="annually">$99.99</h4>}
          <hr />
          <p>Windows, Linux</p>
          <hr />
          <p>Advanced Submission </p>
          <hr />
          <p>
            <b>Submission call daily:</b> 200
          </p>
          <hr />
          <p>
            <b>API call daily:</b> 50
          </p>
          <hr />
          <button onClick={() => loginCall()}>Buy</button>
        </div>
        <div className="pricing__cards-right">
          <h2>Professional</h2>
          {isMonthly ? <h3 className="monthly">$19.99</h3> : <h4 className="annually">$199.99</h4>}
          <hr />
          <p>Windows, Linux, Android</p>
          <hr />
          <p>Advanced Submission </p>
          <hr />
          <p>
            <b>Submission call daily:</b> 500
          </p>
          <hr />
          <p>
            <b>API call daily:</b> 200
          </p>
          <hr />
          <button onClick={() => loginCall()}>Buy</button>
        </div>
      </div>
      <IyzicoIcon />

      <Modal open={isLoginOpen} onClose={() => setIsLoginOpen(false)}>
        <div className="cloudmodal-login">
          <Login />
        </div>
      </Modal>
      <p style={{ paddingTop: "50px" }}>
        Please read our legal agreements before purchasing any plan. If you proceed with the
        purchase without reading them, you will be deemed to have accepted all agreements.
      </p>
      <div>
        <a
          href="#"
          className="pricing__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("privacy");
          }}>
          Privacy Policy
        </a>
        <span className="pricing__pipe"> | </span>
        <a
          href="#"
          className="pricing__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("agreement");
          }}>
          Distance Sales Agreement
        </a>
        <span className="pricing__pipe"> | </span>
        <a
          href="#"
          className="pricing__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("delivery");
          }}>
          Delivery and Refund Terms
        </a>
        <span className="pricing__pipe"> | </span>
        <a
          href="#"
          className="pricing__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("terms");
          }}>
          Terms of Service
        </a>
        <span className="pricing__pipe"> | </span>
        <a className="pricing__link" href="https://cyber-fortress.com/main/about.html">
          About Us
        </a>
        <span className="pricing__pipe"> | </span>
        <a
          href="#"
          className="pricing__link"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick("contact");
          }}>
          Legal
        </a>
      </div>
      <PricePopup isOpen={isPopupOpen} onClose={closePopup} contentType={popupContentType} />
    </div>
  );
};

export default Pricing;
